import React, { useState } from 'react';
import {
  Container,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate, useParams } from 'react-router-dom';
import { GetGrooupStudentDataAPI } from '../../Conections/AcademicConection';


function EstudentGrade() {

  const goTo = useNavigate();
  const params = useParams();

  const [estudianteEjemplo, setEstudianteEjemplo] = useState({
    id:0,
    codigo: '',
    nombre: '',
    apellido: '',
    email: ''
  });

  const [gruposActivosEjemplo, setGruposActivosEjemplo] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedActivity, setSelectedActivity] = useState(null);

  React.useEffect(() => {
    async function reloaduser() {
      let Activity = await GetGrooupStudentDataAPI(params["clave"], params["code"]);

      let estudianteEjemploD = estudianteEjemplo;
      estudianteEjemploD.id = Activity["id"];
      estudianteEjemploD.codigo = Activity["code"];
      estudianteEjemploD.nombre = Activity["firstname"];
      estudianteEjemploD.apellido = Activity["lastname"];
      estudianteEjemploD.email = Activity["email"];
      setEstudianteEjemplo(estudianteEjemploD);

      let gruposActivosEjemploD = Activity["grupos"];
      // console.log(gruposActivosEjemplo);
      console.log(gruposActivosEjemploD);

      if (gruposActivosEjemploD) {
        setGruposActivosEjemplo(gruposActivosEjemploD);
      }

    };
    reloaduser();
  }, [params]);

  const handleOpenDialog = (activity) => {
    setSelectedActivity(activity);
    setOpenDialog(true);
    console.log(activity.estudiante);
    console.log(activity.id);
    goTo("/academic/estudentactivitygrade/"+params["clave"]+"/"+activity.estudiante+"/"+activity.id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ my: 4 }}>
        Calificaciones del Estudiante
      </Typography>

      <Grid container spacing={3}>
        {/* Tarjeta de Información del Estudiante */}
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Información del Estudiante
              </Typography>
              <Typography variant="body1">
                <strong>Código:</strong> {estudianteEjemplo.codigo}
              </Typography>
              <Typography variant="body1">
                <strong>Nombre:</strong> {estudianteEjemplo.nombre}
              </Typography>
              <Typography variant="body1">
                <strong>Apellido:</strong> {estudianteEjemplo.apellido}
              </Typography>
              <Typography variant="body1">
                <strong>Email:</strong> {estudianteEjemplo.email}
              </Typography>
            </CardContent>
          </Card>
        </Grid>

        {/* Acordeón de Grupos Activos */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Grupos Activos
          </Typography>
          {gruposActivosEjemplo.map((grupo) => (
            <Accordion key={grupo.id}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>{grupo.nombre} - Nota: {grupo.nota}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography gutterBottom>{grupo.descripcion}</Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Actividad</TableCell>
                        <TableCell>Descripción</TableCell>
                        <TableCell>Nota</TableCell>
                        <TableCell>Acción</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {grupo.actividades.map((actividad) => (
                        <TableRow key={actividad.id}>
                          <TableCell>{actividad.nombre}</TableCell>
                          <TableCell>{actividad.descripcion}</TableCell>
                          <TableCell>{actividad.nota}</TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => handleOpenDialog(actividad)}
                            >
                              Consultar
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </Grid>

      {/* Diálogo para mostrar detalles de la actividad */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{selectedActivity?.nombre}</DialogTitle>
        <DialogContent>
          <Typography><strong>Descripción:</strong> {selectedActivity?.descripcion}</Typography>
          <Typography><strong>Nota:</strong> {selectedActivity?.nota}</Typography>
          {/* Aquí puedes agregar más detalles de la actividad si es necesario */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default EstudentGrade;

